import LoadingButton from 'ui/components/ButtonV2/LoadingButton';
import type { GenericItem } from '@/client/contentfulClient';
import clsx from 'clsx';
import { DeviceGeneration } from 'ui/utils/constants/maverick';
interface StartYourFreeTrialSectionProps {
  content: GenericItem[];
  onCTAClick: () => Promise<void>;
  isAddingToCart: boolean;
  ctaText?: string;
}
export default function StartYourFreeTrialSection({
  content,
  onCTAClick,
  isAddingToCart,
  ctaText
}: StartYourFreeTrialSectionProps) {
  const contentBlocks = content.find(item => item.name.includes(DeviceGeneration.GOOSE)) ?? content[0];
  if (!contentBlocks) return null;
  return <div className='flex w-full items-center justify-center py-14' data-sentry-component="StartYourFreeTrialSection" data-sentry-source-file="StartYourFreeTrialSection.tsx">
      <div className={clsx('flex w-[88%] max-w-screen-lg flex-col items-center justify-center gap-8 rounded-3xl bg-black px-6 pt-8 md:flex-row md:gap-8 md:px-28 lg:gap-24',
    // background styling
    'bg-black-to-white-gradient')}>
        <div className='order-2 h-72 w-fit overflow-y-hidden md:order-1 md:h-[393px]'>
          {contentBlocks.image ? <img alt={contentBlocks.image.title ?? 'WHOOP content'} className='w-56 md:w-72' data-testid='start-your-free-trial-image' src={contentBlocks.image.url} /> : null}
        </div>
        <div className='order-1 flex flex-col items-center gap-6 text-white md:order-2 md:items-start'>
          {contentBlocks.secondaryImage ? <img alt={contentBlocks.secondaryImage.title ?? 'WHOOP content'} className='w-16 md:w-20' data-testid='start-your-free-trial-secondary-image' src={contentBlocks.secondaryImage.url} /> : null}
          <h2 className='text-4xl font-semibold md:text-5xl'>
            {contentBlocks.title}
          </h2>
          <p className='w-[297px] text-center md:w-80 md:text-start lg:w-[374px]' id='style-override-body-md'>
            {contentBlocks.description}
          </p>
          {ctaText ? <LoadingButton className='max-w-56 text-xs' disabled={isAddingToCart} onClick={onCTAClick} size='medium' variant='transparentWithBorderBright'>
              {ctaText}
            </LoadingButton> : null}
        </div>
      </div>
    </div>;
}